<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'package'"></sideBar>
				<div class="v-content-wrapper">
					<div class="v-content-container">
						<!-- Store Traffic Promotion Package Header -->
						<div class="promotion-header">
							<img src="../../assets/images/level/package.png" alt="Promotion Background"
								class="bg-image" />
							<h1 class="title">{{$t('common.storetrafficpromotionpackage')}}</h1>
						</div>

						<!-- Package Cards -->
						<div class="package-cards-container">
							<div v-for="(planItem, index) in planList" :key="index" class="package-card">
								<div class="icon-wrapper">
									<img :src="planItem.planImg" class="package-icon" />
								</div>
								<h3 class="duration">{{ planItem.planName }}</h3>
								<div class="price">{{ planItem.price }}</div>
								<button class="purchase-btn" @click="handlePurchase(planItem)">
									{{$t('common.purchasepackage')}}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="occupy-space"></div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		planList,
		addPlanOrder
	} from '../../api/level'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				planList: [],
				tabList: [{
						title: this.$t('home.today')
					},
					{
						title: this.$t('home.yesterday')
					},
					{
						title: this.$t('home.last7days')
					},
					{
						title: this.$t('home.last30days')
					},
				],
				tabIndex: 0,

			}
		},
		mounted() {
			this.getLevelList()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			handlePurchase(planItem) {
				this.$confirm(this.$t('tips.confirmpurchasetrafficpromotion'), this.$t('tips.tip'), {
						confirmButtonText: this.$t('button.confirm'),
						cancelButtonText: this.$t('button.cancel'),
						type: 'warning'
					}).then(() => {

						let data = {
							planNo: planItem.planNo,
						}
						addPlanOrder(data).then(res => {
							if (res.code === 200) {
								this.$message({
									message: 'success',
									type: 'success'
								})
							} else {
								this.$message({
									message: res.msg,
									type: 'error'
								})
							}
						})
					})
					.catch();
			},
			getLevelList() {
				planList().then(res => {
					if (res.code === 200) {
						this.planList = res.data;
					}
				})
			},
			changeTab(index) {
				this.tabIndex = index
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/level.css");
</style>
<style scoped>
	.v-content-wrapper {
		margin: 0 20px 0 10px;
	}

	/* Promotion Header */
	.promotion-header {
		position: relative;
		width: 100%;
		height: 180px;
		overflow: hidden;
		border-radius: 8px;
		margin-bottom: 20px;
	}

	.bg-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.title {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 2rem;
		font-weight: bold;
		color: #000;
		text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
		z-index: 1;
	}

	/* Package Cards Container */
	.package-cards-container {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
		justify-content: space-between;
		/* 改为 space-between */

	}

	.package-card {
		background-color: #fff;
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		padding: 20px;
		width: calc(33.33% - 20px);
		/* 保持原有宽度 */
		box-sizing: border-box;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		transition: transform 0.3s ease;
		text-align: center;
	}

	.package-card:hover {
		transform: translateY(-5px);
	}

	.icon-wrapper {
		margin-bottom: 15px;
	}

	.package-icon {
		width: 60px;
		height: 60px;
		object-fit: contain;
	}

	.duration {
		font-size: 1.1rem;
		margin-bottom: 15px;
	}

	.price {
		font-size: 2rem;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.purchase-btn {
		background-color: #007BFF;
		color: white;
		border: none;
		padding: 10px 20px;
		border-radius: 4px;
		cursor: pointer;
		font-size: 0.9rem;
		transition: background-color 0.3s ease;
	}

	.purchase-btn:hover {
		background-color: #0056b3;
	}

	/* Responsive Design for H5 */
	@media (max-width: 768px) {
		.package-cards-container {

			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}


		.package-card {
			width: 100%;
		}

		.title {
			font-size: 1.5rem;
		}

		.duration {
			font-size: 1rem;
		}

		.price {
			font-size: 1.5rem;
		}
	}

	@media (max-width: 480px) {
		.package-cards-container {

			grid-template-columns: repeat(1, minmax(0px, 1fr));
		}


		.package-card {
			width: 100%;
		}

		.promotion-header {
			height: 150px;
		}

		.title {
			font-size: 1.2rem;
		}

		.purchase-btn {
			padding: 8px 16px;
			font-size: 0.8rem;
		}
	}
</style>
